import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { BrowseCourse } from '@udemy-v2/browse-course';
import { BrowseEventTrackingProvider } from '@udemy-v2/react-browse-event-tracking';
import { ShowMore } from '@udemy-v2/react-reveal-components';
import { Button, ButtonProps } from '@udemy-v2/react-core-components';
import { CondensedBrowseCourseCard } from './components/condensed-browse-course-card';
import styles from './students-also-bought.module.scss';
import classNames from 'classnames';

// Number of courses to display before showing the "Show More" button
const DISPLAYED_COURSES_COUNT = 6;
const ShowMoreButton = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Button {...props} udStyle="secondary">{props.children}</Button>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
interface StudentsAlsoBoughtProps {
  courses: BrowseCourse[];
  title: string;
}
export const StudentsAlsoBought = t0 => {
  const $ = _c(11);
  const {
    courses,
    title
  } = t0;
  if (!courses.length) {
    return null;
  }
  const hiddenCoursesCount = courses.length - DISPLAYED_COURSES_COUNT;
  let t1;
  if ($[0] !== courses) {
    t1 = courses.map(_temp);
    $[0] = courses;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const courseCards = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames(styles["unit-heading"], "ud-heading-xl");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== title) {
    t3 = <h2 className={t2}>{title}</h2>;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== courseCards || $[6] !== hiddenCoursesCount) {
    t4 = hiddenCoursesCount > 0 ? <ShowMore collapsedHeight={700} fullWidthButton={true} buttonComponent={ShowMoreButton} hideIcons={true} className={styles["show-more"]} data-purpose="show-more-container"><div className={styles["grid-container"]} data-purpose="show-more-content-container">{courseCards}</div></ShowMore> : <div className={styles["grid-container"]} data-purpose="short-list-content-container">{courseCards}</div>;
    $[5] = courseCards;
    $[6] = hiddenCoursesCount;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className={styles.container}>{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
function _temp(course, idx) {
  return <BrowseEventTrackingProvider key={course.id} browseEventTrackingContext={{
    index: idx
  }}><CondensedBrowseCourseCard course={course} /></BrowseEventTrackingProvider>;
}